// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b644c76c","553":"7b046c4d","977":"eb21b594"}[chunkId] + ".chunk.js";
};